import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Fade } from "@mui/material";

const images = [
  "https://design247bucket.s3.ap-south-1.amazonaws.com/home99.png",
  "https://design247bucket.s3.ap-south-1.amazonaws.com/home55.png",
  "https://design247bucket.s3.ap-south-1.amazonaws.com/home10img.png",
];

const texts = [
  "Transform Your Spaces with Premium Designs",
  "Interior Solutions That Speak Your Style",
  "Design. Connect. Build with Us Today",
];

const HomeSlider = ({ setOpenLogin, setToggleForm }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Box sx={{ position: "relative", height: { xs: 400, md: "90vh" }, width: "100%", overflow: "hidden" }}>
      {images.map((image, i) => (
        <Fade in={i === index} timeout={800} key={i}>
          <Box
            sx={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              display: i === index ? "flex" : "none",
              alignItems: "center",
              pl: { xs: 3, sm: 8 },
              pt:"50px",
            }}
          >
            <Box sx={{ width: { xs: "300px", md: "500px" } }}>
              <Typography
                variant="h4"
                sx={{
                   fontWeight:'600',
                    color: "black",
                  mb: 3,
                  fontSize: { xs: "24px", md: "42px" },
                  textShadow: "2px 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                {texts[i]}
              </Typography>
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: "#1dbf73",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "none",
                  px: 4,
                  py: 1.5,
                  fontSize: "16px",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#17a65e",
                    transform: "scale(1.05)",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                  },
                  transition: "all 0.3s ease",
                }}
                onClick={() => {
                  setOpenLogin(true);
                  setToggleForm("signup");
                }}
              >
                Get Started
              </Button>
            </Box>
          </Box>
        </Fade>
      ))}
    </Box>
  );
};

export default HomeSlider;
